/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-15 08:18:35 */

const Keys = {
  noSearchChangeMessage: 'noSearchChangeMessage',
  backToList: 'backToList',
  bookingErrorModalBody: 'bookingErrorModalBody',
  bookingErrorModalButton: 'bookingErrorModalButton',
  onContinueLoadingText: 'onContinueLoadingText',
  adjustNumberTraveler: 'adjustNumberTraveler',
  searchYellowSunFlightOnly: 'searchYellowSunFlightOnly',
  maxOccupancyModalTitle: 'maxOccupancyModalTitle',
  maxOccupancyModalDescription: 'maxOccupancyModalDescription',
  childAgePickerHeader: 'childAgePickerHeader'
}; export default Keys;